import { c as _c } from "react/compiler-runtime";
// Карточка заказа по макету «Профиль» (кадр 6): крошки «Мои заказы › Заказ №…»;
// слева блок 440×146 r16 — степпер «Оплачено · В обработке · Доставка · Получите»
// (пройденные шаги — зелёная галочка #32D47D), под ним статус 16px, дата и время
// 14px #1F1F1F 48 %, сумма; справа две карточки 354×68 r16 со стрелкой —
// «В пункт выдачи <дата> / СДЭК, адрес» и «Получатель / имя, телефон» (по клику —
// детали доставки с трекингом и контакты). «Товары» — карточки 810 r16, фото
// 100×133 r16; сводка r16: N товаров, «Скидка OSMIX» (#FA5C2E), доставка, итого 24px.

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@osmix/ui/dialog";
import { Skeleton } from "@osmix/ui/skeleton";
import { useQuery } from "@tanstack/react-query";
import { Truck } from "lucide-react";
import { useState } from "react";
import { Link, useParams } from "react-router";
import { api, type Order, type OrderShipment } from "@/api";
import { SelfDeliverySteps } from "@/components/orders/self-delivery-steps";
import { isSellerPickupGroup, SellerPickupCard } from "@/components/orders/seller-pickup-card";
import { carrierName, trackingUrl } from "@/lib/delivery-labels";
import { InvoiceView } from "@/components/orders/invoice-view";
import { OrderActions } from "@/components/profile/order-actions";
import { BoxIcon, Check20Icon, ChevronRightIcon, MarkerPin20Icon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { dayMonth, expectedDelivery, isIndividualOrder, ORDER_STEPS, orderNumber, orderStatusColor, orderStatusLabel, orderStep, pluralRu, readyDateLabel, shortDate, shortTime, statusAt } from "@/components/profile/order-view";
import { ProfilePanel } from "@/components/profile/profile-shell";
import { useFormatPrice } from "@/lib/use-format-price";
import { cn } from "@/lib/utils";
import { useProfile } from "@/store";
const OVERLAY = "bg-black/20 backdrop-blur-[2px]";
// Иконки шагов — набор макета (check 1, Box, marker-pin 1); грузовика в наборе
// DS нет — lucide того же размера и толщины.
const STEP_ICONS: Array<(props: {
  className?: string;
}) => React.ReactNode> = [p => <Check20Icon {...p} />, p => <BoxIcon size={20} {...p} />, p => <Truck className={cn("size-5", p.className)} strokeWidth={1.5} />, p => <MarkerPin20Icon {...p} />];
export function ProfileOrderPage() {
  const $ = _c(35);
  const {
    orderId: t0
  } = useParams();
  const orderId = t0 === undefined ? "" : t0;
  const userId = useProfile(_temp);
  let t1;
  if ($[0] !== orderId || $[1] !== userId) {
    t1 = ["buyer", userId, "orders", orderId];
    $[0] = orderId;
    $[1] = userId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== orderId) {
    t2 = () => api.buyer.getOrder(orderId);
    $[3] = orderId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = Boolean(orderId);
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      retry: false
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const order = useQuery(t4);
  let t5;
  if ($[9] !== orderId || $[10] !== userId) {
    t5 = ["buyer", userId, "orders", orderId, "shipments"];
    $[9] = orderId;
    $[10] = userId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== orderId) {
    t6 = () => api.orders.shipments(orderId);
    $[12] = orderId;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = Boolean(order.data);
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = {
      queryKey: t5,
      queryFn: t6,
      enabled: t7,
      retry: false
    };
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const shipments = useQuery(t8);
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      label: "\u041C\u043E\u0438 \u0437\u0430\u043A\u0430\u0437\u044B",
      to: "/profile/orders"
    };
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = `Заказ №${orderNumber(orderId, order.data?.number)}`;
  let t11;
  if ($[19] !== t10) {
    t11 = [t9, {
      label: t10
    }];
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const crumbs = t11;
  if (order.isPending) {
    let t12;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <Skeleton className="h-[146px] rounded-[16px] bg-white" />;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    let t13;
    if ($[22] !== crumbs) {
      t13 = <ProfilePanel crumbs={crumbs}>{t12}</ProfilePanel>;
      $[22] = crumbs;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    return t13;
  }
  if (order.isError || !order.data) {
    let t12;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <div className="rounded-[16px] bg-white p-8 text-center"><p className="text-[16px] font-medium text-[#161616]">Заказ не найден</p><p className="mt-1 text-[14px] text-[#1F1F1F]/48">Возможно, он оформлен с другого аккаунта.</p></div>;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    let t13;
    if ($[25] !== crumbs) {
      t13 = <ProfilePanel crumbs={crumbs}>{t12}</ProfilePanel>;
      $[25] = crumbs;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    return t13;
  }
  let t12;
  if ($[27] !== shipments.data) {
    t12 = shipments.data ?? [];
    $[27] = shipments.data;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== order.data || $[30] !== t12) {
    t13 = <OrderBody order={order.data} shipments={t12} />;
    $[29] = order.data;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== crumbs || $[33] !== t13) {
    t14 = <ProfilePanel crumbs={crumbs}>{t13}</ProfilePanel>;
    $[32] = crumbs;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
}
function _temp(s) {
  return s.user?.id ?? "guest";
}
function OrderBody({
  order,
  shipments
}: {
  order: Order;
  shipments: OrderShipment[];
}) {
  const fmt = useFormatPrice();
  const [dialog, setDialog] = useState<"delivery" | "recipient" | null>(null);
  const step = orderStep(order.status);
  const at = statusAt(order);
  const items = order.groups.flatMap(g => g.items.map(item => ({
    item,
    group: g
  })));
  const discount = order.discount ?? 0;
  const discountPct = order.subtotal > 0 ? Math.round(discount / order.subtotal * 100) : 0;
  const first = order.groups[0]?.shipment;
  const toPoint = Boolean(first?.toPickupPoint || first?.pvzAddress);
  const eta = expectedDelivery(order);
  const readyDate = readyDateLabel(order);
  const individual = isIndividualOrder(order);
  const carrier = carrierName(first?.carrier);
  const place = first?.pvzAddress || [order.address.city, order.address.street].filter(Boolean).join(", ");
  // Самовывоз от продавца: точка вместо пункта выдачи перевозчика.
  const pickupGroups = order.groups.filter(isSellerPickupGroup);
  const pickupPoint = first?.carrier === "seller_pickup" ? first.pickupPoint : undefined;
  return <div className="flex flex-col">
			<div className="grid grid-cols-[minmax(0,1fr)] gap-2.5 md:grid-cols-[minmax(0,440fr)_minmax(0,354fr)] md:gap-4">
				<section className="min-w-0 rounded-[16px] bg-white p-2.5">
					<ol className="grid grid-cols-[auto_minmax(6px,26px)_auto_minmax(6px,26px)_auto_minmax(6px,26px)_auto] items-start justify-between gap-x-1 py-[15px] sm:gap-x-1.5">
						{ORDER_STEPS.map((label, i) => {
            const Icon = STEP_ICONS[i] ?? STEP_ICONS[0]!;
            const done = i <= step;
            return <li key={label} className="contents">
									{i > 0 && <span aria-hidden="true" className="mt-[11px] w-full border-t border-dashed border-[#1F1F1F]/40" />}
									<span className="flex flex-col items-center gap-1.5 text-center">
										{done ? <Check20Icon className="text-ds-success" /> : <Icon className="text-black/50" />}
										<span className={cn("text-[11px] leading-[13px] font-medium tracking-[-0.22px] whitespace-nowrap", done ? "text-[#32D47D]" : "text-black/50")}>{label}</span>
									</span>
								</li>;
          })}
					</ol>
					<div className="mt-2.5 flex items-start justify-between gap-3">
						<p className="text-[16px] leading-5 font-semibold tracking-[-0.31px]" style={{
            color: order.status === "delivered" ? "#1F1F1F" : orderStatusColor(order.status)
          }}>
							{orderStatusLabel(order.status)}
						</p>
						<p className="shrink-0 text-[12px] leading-4 text-black/50">
							{shortDate(at)}
							<span className="ml-2">{shortTime(at)}</span>
						</p>
					</div>
					<p className="mt-2 text-[14px] leading-[18px] text-[#1F1F1F]">{fmt(order.total)}</p>
					{/* Дата, которую назвал продавец (fd-order-08), и метка индивидуального
         заказа (fd-request-13) — под суммой, тем же мелким текстом. */}
					{readyDate || individual ? <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1">
							{individual ? <span className="rounded-full bg-[#F2F2F2] px-2 py-0.5 text-[12px] leading-4 font-medium text-[#1F1F1F]" data-testid="order-individual">
									Индивидуальный заказ
								</span> : null}
							{readyDate ? <span className="text-[12px] leading-4 text-black/50" data-testid="order-ready-date">
									Ориентировочная дата готовности: {readyDate}
								</span> : null}
						</div> : null}
				</section>

				<div className="flex flex-col gap-2.5">
					<InfoLink title={pickupPoint ? "Самовывоз из магазина" : toPoint ? `В пункт выдачи${eta ? ` ${dayMonth(eta)}` : ""}` : `Курьером${eta ? ` ${dayMonth(eta)}` : ""}`} subtitle={pickupPoint ? `${pickupPoint.name},  ${[pickupPoint.city, pickupPoint.address].join(", ")}` : `${carrier},  ${place}`} onClick={() => setDialog("delivery")} />
					<InfoLink title="Получатель" subtitle={`${order.contact.name},  ${order.contact.phone}`} onClick={() => setDialog("recipient")} />
				</div>
			</div>

			{pickupGroups.map(g_0 => <SellerPickupCard key={g_0.shopId} group={g_0} className="mt-2.5" />)}

			{/* «Отменить заказ» / «Подтвердить получение» (fd-order-03) — по статусу. */}
			<OrderActions order={order} className="mt-2.5" />

			<h2 className="mt-4 mb-2.5 text-[16px] leading-5 font-semibold tracking-[-0.31px] text-black">Товары</h2>
			<div className="flex flex-col gap-2.5">
				{items.map(({
        item: item_0,
        group
      }, i_0) => <article key={`${item_0.productId}-${item_0.variantId ?? item_0.size}-${i_0}`} className="flex gap-3 rounded-[20px] bg-white p-2">
						<Link to={`/product/${item_0.productId}`} className="relative block h-[133px] w-[100px] shrink-0 overflow-hidden rounded-[16px] bg-white outline-none focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40">
							{item_0.photo ? <img src={item_0.photo} alt={item_0.name} className="size-full object-cover" /> : null}
							{/* Обводка фото #EFEFEF по кадру — поверх картинки. */}
							<span aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-[16px] shadow-[inset_0_0_0_1px_#EFEFEF]" />
						</Link>
						<div className="flex min-w-0 flex-1 flex-col">
							<p className="text-[16px] leading-5 font-semibold text-[#333]">{fmt(item_0.unitPrice)}</p>
							<p className="mt-1.5 text-[14px] leading-[15px] font-semibold tracking-[-0.28px] text-[#161616]">{item_0.brand || group.shopName}</p>
							<p className="mt-1 text-[12px] leading-4 font-medium tracking-[-0.24px] text-[#797979]">
								{item_0.name}
								{item_0.variantLabel || item_0.size ? <>
										,<br />
										{item_0.variantLabel || [item_0.size, item_0.color].filter(Boolean).join(", ")}
									</> : null}
							</p>
							<p className="mt-auto self-end text-[14px] leading-[18px] text-black/50">{item_0.qty} шт.</p>
						</div>
					</article>)}
			</div>

			<section className="mt-2.5 flex flex-col gap-2.5 rounded-[16px] bg-white p-2.5">
				<Row label={`${order.itemCount} ${pluralRu(order.itemCount, "товар", "товара", "товаров")}`} value={<span className="font-bold">{fmt(order.subtotal)}</span>} />
				{discount > 0 && <Row label={<span className="text-[14px] leading-[15px] tracking-[-0.28px] text-[#FA5C2E]">Скидка OSMIX</span>} value={<span className="text-[14px] leading-[19px] tracking-[-0.28px]">
								<span className="font-bold text-[#FA5C2E]">{fmt(discount)}</span>
								<span className="ml-1 text-[12px] font-medium tracking-[-0.24px] text-[#797979]">−{discountPct}%</span>
							</span>} />}
				<Row label="Доставка" value={<span className="font-bold">{fmt(order.deliveryTotal)}</span>} />
				{order.balanceApplied ? <Row label="Оплачено балансом" value={<span className="font-bold">{fmt(order.balanceApplied)}</span>} /> : null}
				<div className="mt-1.5 flex items-center justify-between gap-3">
					<span className="text-[16px] leading-5 font-semibold tracking-[-0.31px] text-[#161616]">Итого</span>
					<span className="text-[24px] leading-[33px] font-bold tracking-[-0.48px] text-[#161616]">{fmt(order.total)}</span>
				</div>
			</section>

			{order.paymentMethod === "invoice" && <InvoiceBlock orderId={order.id} />}

			<Dialog open={dialog !== null} onOpenChange={open => !open && setDialog(null)}>
				<DialogContent overlayClassName={OVERLAY} className="gap-4 rounded-[20px] border-0 p-5 sm:max-w-[420px]">
					<DialogHeader>
						<DialogTitle className="text-[20px] font-medium text-[#161616]">
							{dialog === "recipient" ? "Получатель" : "Доставка"}
						</DialogTitle>
					</DialogHeader>
					{dialog === "recipient" ? <dl className="flex flex-col gap-2 text-[14px]">
							<DetailRow label="Имя" value={order.contact.name} />
							<DetailRow label="Телефон" value={order.contact.phone} />
							{order.contact.email ? <DetailRow label="Почта" value={order.contact.email} /> : null}
						</dl> : <div className="flex flex-col gap-3 text-[14px]">
							{order.groups.map(g_1 => {
            const s = shipments.find(x => x.shopId === g_1.shopId);
            const last = s?.statusHistory.at(-1);
            return <div key={g_1.shopId} className="rounded-[12px] bg-[#F8F8F8] p-3">
										<p className="font-medium text-[#161616]">{g_1.shopName}</p>
										<p className="mt-1 text-[#1F1F1F]/64">
											{carrierName(g_1.shipment?.carrier)}
											{g_1.shipment?.tariffName && g_1.shipment.tariffName !== carrierName(g_1.shipment.carrier) ? ` · ${g_1.shipment.tariffName}` : ""}
											{/* Срок уже приходит с единицей («2–4 дн.»), второй «дн.» не нужен. */}
											{g_1.shipment?.deliveryDays ? ` · ${g_1.shipment.deliveryDays}` : ""}
										</p>
										<p className="mt-1 text-[#1F1F1F]">
											{g_1.shipment?.pvzAddress || [order.address.city, order.address.street].filter(Boolean).join(", ")}
										</p>
										{g_1.shipment?.pvzWorkTime ? <p className="mt-1 text-[#1F1F1F]/64">{g_1.shipment.pvzWorkTime}</p> : null}
										{(s?.carrier ?? g_1.shipment?.carrier) === "self" ? <div className="mt-2">
												<SelfDeliverySteps statusCode={s?.statusCode} comment={last?.comment} />
											</div> : null}
										{s?.cdekNumber || s?.trackingNumber || order.trackingNumber ? <p className="mt-1 text-[#1F1F1F]/64">
												Трек-номер:{" "}
												{trackingUrl(s?.carrier, s?.cdekNumber) ? <a href={trackingUrl(s?.carrier, s?.cdekNumber)} target="_blank" rel="noreferrer" className="text-[#1F1F1F] underline underline-offset-2">
														{s?.cdekNumber}
													</a> : s?.cdekNumber || s?.trackingNumber || order.trackingNumber}
											</p> : null}
										{last && (s?.carrier ?? g_1.shipment?.carrier) !== "self" ? <p className="mt-1 text-[#1F1F1F]/64">
												{last.name || s?.statusName}
												{last.at ? ` · ${shortDate(last.at)} ${shortTime(last.at)}` : ""}
											</p> : null}
									</div>;
          })}
						</div>}
				</DialogContent>
			</Dialog>
		</div>;
}
function InfoLink(t0) {
  const $ = _c(11);
  const {
    title,
    subtitle,
    onClick
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <span className="block truncate text-[16px] leading-5 font-semibold tracking-[-0.31px] text-[#1F1F1F]">{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subtitle) {
    t2 = <span className="mt-[7px] block truncate text-[14px] leading-[18px] text-black">{subtitle}</span>;
    $[2] = subtitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <span className="min-w-0">{t1}{t2}</span>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronRightIcon size={24} className="shrink-0 text-[#333]" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onClick || $[9] !== t3) {
    t5 = <button type="button" onClick={onClick} className="flex min-h-[68px] w-full items-center justify-between gap-3 rounded-[16px] bg-white p-2.5 text-left outline-none transition-shadow hover:shadow-[0_2px_12px_rgba(0,0,0,0.06)] focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40">{t3}{t4}</button>;
    $[8] = onClick;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function Row(t0) {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span>{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <span className="shrink-0 text-right">{value}</span>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex items-center justify-between gap-3 text-[16px] leading-5 font-semibold tracking-[-0.31px] text-[#161616]">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function DetailRow(t0) {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <dt className="text-[#1F1F1F]/48">{label}</dt>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <dd className="text-right text-[#161616]">{value}</dd>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex justify-between gap-3">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

// Оплата по счёту (fd-payment-02): счёт открывается по запросу, печать/PDF — в InvoiceView.
function InvoiceBlock(t0) {
  const $ = _c(17);
  const {
    orderId
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== orderId) {
    t1 = ["buyer", "invoice", orderId];
    t2 = () => api.buyer.getOrderInvoice(orderId);
    $[0] = orderId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== open || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2,
      enabled: open,
      retry: false
    };
    $[3] = open;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const invoice = useQuery(t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div><p className="text-[16px] font-medium text-[#161616]">Счёт на оплату</p><p className="text-[14px] text-[#1F1F1F]/48">Заказ оформлен на оплату по счёту</p></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpen(_temp4);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = open ? "\u0421\u043A\u0440\u044B\u0442\u044C \u0441\u0447\u0451\u0442" : "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u0447\u0451\u0442";
  let t7;
  if ($[9] !== t6) {
    t7 = <div className="flex items-center justify-between gap-3">{t4}<Button variant="gray" size="sm" data-testid="view-invoice" onClick={t5}>{t6}</Button></div>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== invoice || $[12] !== open) {
    t8 = open && (invoice.isPending ? <Skeleton className="h-64 rounded-[12px]" /> : invoice.isError ? <p className="text-[14px] text-[#E1574F]">{invoice.error instanceof Error ? invoice.error.message : "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0447\u0451\u0442"}</p> : invoice.data ? <InvoiceView invoice={invoice.data} /> : null);
    $[11] = invoice;
    $[12] = open;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <section className="mt-2.5 flex flex-col gap-3 rounded-[16px] bg-white p-4">{t7}{t8}</section>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
function _temp4(v) {
  return !v;
}